<template>
  <div class="main-bg">
    <v-img :src="mainBg" alt="main-bg" class="full-height-image" cover></v-img>
  </div>
</template>

<script>
export default {
    name: "MainAuth",
    data() {
        return {
            mainBg: require("../../../assets/Images/Auth/login-background.png"),
        }
    }
}
</script>

<style scoped>
.main-bg {
  position: relative;
  min-width: 0;
  height: 100vh;
  overflow: hidden;
}

.full-height-image {
  position: absolute;
  width: 100%;
  height: 100%;
  max-height: none;
  object-fit: cover;
  object-position: center;
}
</style>